module.exports = __webpack_public_path__ + "static/media/21-8.46e24709.mp3";